import { DateTime } from "luxon";

function generatePaymentOsQueryEncoding(riderId) {
  const query = {
    liveTestEnv: "live",
    gte: DateTime.now().minus({ days: 60 }),
    q: riderId,
    page: 0,
  };

  const json = JSON.stringify(query);
  const encodedParams = Buffer.from(json).toString("base64");
  return encodedParams;
}

export default function getPaymentProfileUrl(provider, riderId = null) {
  const providerUrls = {
    PaymentsOS: `https://control.paymentsos.com/payments/search?${generatePaymentOsQueryEncoding(
      riderId,
    )}`,
    Paypal: `https://www.braintreegateway.com/merchants/${window.REACT_APP_PAYPAL_MERCHANT_ID}/transactions/advanced_search`,
    Stripe: `https://dashboard.stripe.com/search?query=${riderId}`,
  };

  return providerUrls[provider];
}
